<template>
  <div id="app">
    <div v-if="tournamentData && tournamentData.length>0">
      <Event v-bind:tournament-data="tournamentData" />
    </div>
    <div v-else class="tournament-title">
      {{noTournamentsMessage}}
      <br />
      <span
        class="refresh-message"
      >(Try clearing your cache and/or refreshing the page if this seems incorrect.)</span>
    </div>
  </div>
</template>





<script>
import Event from "./components/Event.vue";
import axios from "axios";
// import Request from "axios-request-handler";
import moment from "moment";

const aelogo = require("@/assets/aegraphics_logo.png");

export default {
  name: "app",
  components: {
    Event
  },
  data() {
    return {
      tennisData: {},
      tournamentData: [],
      noTournamentsMessage: "NO TOURNAMENTS AVAILABLE",
      loadingTournament: true,
      errorTournament: false,
      loadingData: true,
      notLoadedIds: new Set(),
      aelogo,
      polling: null
    };
  },

  created: function() {
    axios
      .get("data/events.json") // from localhost 'public' folder
      .then(response => {
        // this.eventsData = response.data;
        // ALL EVENTS

        // Check if there is a current tournament to display
        this.tournamentData = this.getCurrentTournaments(response.data);
        if (this.tournamentData.length > 0) {
          this.$store.dispatch("setNumTournaments", this.tournamentData.length);
          // this.tournamentData = this.getCurrentTournaments(response.data);
          this.loadTennisData();
        }
      })
      .catch(error => {
        console.log(error);
        this.errorTournament = true;
      })
      .finally(() => (this.loadingTournament = false));
  },

  methods: {
    getCurrentTournaments(tournaments) {
      console.log("getCurrentTournaments()");

      let currentTournaments = [];
      let format = "YYYY-MM-DD";

      // SET THESE DATES FOR TESTING ONLY
      //let today = moment("2020-01-02", format);
      //let tomorrow = moment("2020-01-02", format).add(1, "day");

      let today = moment();
      let tomorrow = moment().add(1, "day");

      let i;
      for (i = 0; i < tournaments.events.length; i++) {
        let startDate = moment(tournaments.events[i].startDate, format);
        let endDate = moment(tournaments.events[i].endDate, format);

        // console.log(startDate);
        // console.log(endDate);
        // console.log(today);
        // console.log(today.isBetween(startDate, endDate, 'days', '[]'));

        // https://momentjs.com/docs/#/query/
        if (
          today.isBetween(startDate, endDate, "days", "[]") ||
          tomorrow.isBetween(startDate, endDate, "days", "[]")
        ) {
          // While here, add a "dataAvailable" property to each tournament and set to false as a default.
          // To be used to set the tournament buttons in EventSelect to disabled when data is not loaded.
          tournaments.events[i]["dataAvailable"] = false;

          currentTournaments.push(tournaments.events[i]);
        }
      }

      return currentTournaments;
    },

    loadTennisData() {
      console.log("loadTennisData()");

      let i;
      for (i = 0; i < this.tournamentData.length; i++) {
        let id = this.tournamentData[i].id;
        this.loadTournamentData(id);
      }
    },
    loadTournamentData(id) {
     // console.log("loadTournamentData() " + id);
      try {
        axios
          // .get("http://localhost/data/" + id + "/get_data.php?timestamp=" + new Date().getTime())
          .get("data/" + id + "/get_data.php?timestamp=" + new Date().getTime())
          .then(response => {
            // console.log(response.data);
            // console.log(typeof response.data);
            // console.log (response.headers["content-type"]);
            // console.log(response.headers["content-type"].indexOf(
            //       "application/json"
            //     ) >= 0);

            // Check the repsonse is valid and should be added to the store
            // https://github.com/axios/axios/issues/61 see jmkenz post
            if (
              response.headers &&
              response.headers["content-type"] &&
              response.headers["content-type"].indexOf("application/json") >=
                0 &&
              typeof response.data == "string"
            ) {
              console.log(
                "(getdata) BAD RESPONSE for " + id + " " + response.data
              );

              if (response.data === "NO DATA FILES FOUND") {
                this.reloadTournamentData(id, 5000);
              } else {
                this.reloadTournamentData(id, 1000);
              }
            } else {
           // console.log(response.data);
                  this.setTournamentData(id, response.data);
            }
          })
          .catch(error => {
            console.log(error);
            // This only has to run on page load. Once data has loaded successfully just once
            // the data will be cached for display so no need to grey out the tournament.
            this.tournamentData.find(
              tournament => tournament.id == id
            ).dataAvailable = false;
          });
      } catch (error) {
         console.log(error);
        // Data for this id did not load
      }
    },
    setTournamentData(id, responseData) {
      // console.log("setTournamentData() " + id);

      console.log(responseData);






      this.tournamentData.find(
        tournament => tournament.id == id
      ).dataAvailable = true;

      if (this.tournamentData.length > 1) {
        // Multiple tournaments running concurrently
        // Must use Vue.set() for multiple tournaments as we're adding a new property (tournamentId) to the this.tennisData object.
        // Without using Vue.set(), the new property will NOT be reactive.
        // https://www.telerik.com/blogs/so-what-actually-is-vue-set
        this.$set(this.tennisData, id, responseData);
      } else {
        this.tennisData = responseData;
      }



      // Add this.tennisData  to the store if responseData is not null which can happen for some reason!


      if(responseData!=null){
         this.$store.dispatch("setTennisData", this.tennisData);
      }



      // Reload the tournamant data in 5000 millisecs
      this.reloadTournamentData(id, 5000);








    },
    reloadTournamentData(id, interval) {
     // console.log("reloadTournamentData() " + id);
      setTimeout(this.loadTournamentData, interval, id);
    }
  }
};
</script>

<style>


#app {
  font-family: 'GeneralSans Medium';  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  /* margin-top: 60px; */
  min-width: 1480px;
  padding: 20px;
  

}

.tournament-title {
  font-weight: bold;
  font-size: 1.5rem;
  
}

.refresh-message {
  font-size: 1rem;
}
</style>